module.exports = __webpack_public_path__ + "static/media/jdl.f1b59a36.png";